module.exports = __webpack_public_path__ + "img/BIT_white38.7f9b0ba9.jpg";